import { serverCall } from 'utils/serverCall';
import { deleteItemRequest, deleteItemSuccess, deleteItemFailure } from './action';
import toast from 'react-hot-toast';
import { fetchUserList } from 'components/userList/redux/dispatcher';

export const deleteItem = ({data, apiEndpoint, flagName, setModal, setIsDelete, setSearchQuery, setSelectedRoleType}) => async (dispatch) => {
  dispatch(deleteItemRequest());
  try {
    const result = await serverCall(apiEndpoint, 'POST',dispatch, data);
    if (result.success) {
      setModal((prev)=> !prev)
      setIsDelete((prev) => !prev)
      dispatch(deleteItemSuccess());
      toast.success(result?.data?.message)
      if(flagName == 'userList'){
        setSearchQuery('')
        setSelectedRoleType('')
        dispatch(fetchUserList());
      }
    } else {
      toast.error(result.message)
      dispatch(deleteItemFailure(result.message));
    }
  } catch (error) {
    dispatch(deleteItemFailure(error.message));
    toast.error(error.message)
  }
};




